'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (input) {
  if (input) return input.replace(/\+\d(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};